import { useNavigate } from 'react-router-dom';

const reasons = [
  { icon: 'ri-shield-check-line', title: '3 個月維修保固', desc: '所有維修項目提供 3 個月保固，維修後發生相同問題免費重修' },
  { icon: 'ri-tools-line', title: '原廠規格零件', desc: '使用原廠同等級零件，保留裝置原有功能與效能' },
  { icon: 'ri-time-line', title: '多數當日完工', desc: '螢幕及電池等常見維修通常 1-3 小時內完成，快速取件' },
  { icon: 'ri-money-dollar-circle-line', title: '透明報價不二價', desc: '維修前提供完整費用說明，無隱藏費用，不擅自更換零件' },
  { icon: 'ri-user-star-line', title: '專業認證技師', desc: '維修人員具備專業認證，豐富的維修經驗與持續訓練' },
  { icon: 'ri-heart-line', title: '免費到店診斷', desc: '帶機到店即可免費檢測問題，不維修不收費' },
];

export default function WhyUsSection() {
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Image */}
          <div className="relative">
            <img
              src="https://ollumiosiejdxqaygglt.supabase.co/storage/v1/object/public/news-images/site-images/whyus1.jpg"
              alt="專業技師"
              className="w-full h-[500px] object-cover object-top rounded-2xl"
            />
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-orange-500 text-white rounded-2xl p-6 text-center">
              <div className="text-3xl font-bold">5000+</div>
              <div className="text-sm opacity-90 mt-1">成功維修案例</div>
            </div>
            <div className="absolute -top-6 -left-6 bg-white border border-gray-100 rounded-2xl p-4">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center bg-yellow-50 rounded-xl">
                  <i className="ri-star-fill text-yellow-400 text-lg" />
                </div>
                <div>
                  <div className="font-bold text-gray-900">4.9 / 5.0</div>
                  <div className="text-xs text-gray-500">Google 評分</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right */}
          <div>
            <div className="inline-flex items-center gap-2 text-orange-500 text-sm font-medium mb-4">
              <span className="w-8 h-px bg-orange-500" />
              為什麼選擇我們
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              專業、誠信、<br />
              <span className="text-orange-500">值得信賴</span>
            </h2>
            <p className="text-gray-500 mb-10 leading-relaxed">
              多年維修經驗，服務超過 5,000 位客戶。我們以技術品質與客戶信任為最高原則。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {reasons.map((r) => (
                <div key={r.title} className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-orange-50 rounded-xl flex-shrink-0">
                    <i className={`${r.icon} text-orange-500`} />
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 text-sm mb-1">{r.title}</div>
                    <div className="text-gray-500 text-xs leading-relaxed">{r.desc}</div>
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={() => navigate('/contact')}
              className="mt-10 px-8 py-3.5 bg-gray-900 hover:bg-gray-800 text-white font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer"
            >
              立即聯絡我們
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
